import Toast from "../../common/components/ui/toast";
import { ToastProvider } from "../../common/components/ui/toast/toast.provider";
import Dashboard from "../../common/components/layout/Dashboard";
import { TableInventoryManagement } from "./components/TableInventoryManagement";

function InventoryManagementPage() {

  return (
    <ToastProvider>
      <Dashboard>
        <TableInventoryManagement />
      </Dashboard>
      <Toast />
    </ToastProvider>
  )
}

export default InventoryManagementPage